<template>
	<div class="messages container">
		<div class="row mb-8">
			<div class="col-12">
				<h1 class="text-danger">{{ $t("serious-concern") }}</h1>
			</div>
		</div>
		<div class="row" v-if="users.length">
			<div class="col-12 col-lg-8">
				<div class="clearfix mb-4">
					<div
						class="pseudo-input"
						:class="{ error: recipientsError }"
						data-cy="message-recipients"
					>
						<input
							type="search"
							class="input-bare w-full flex-1"
							data-cy="message-user-search"
							:placeholder="$t('to-colon')"
							v-if="!recipients.length"
							@click="openModal"
						/>
						<span
							class="badge badge-secondary badge-sm mr-2 mb-2"
							v-for="(recipient, index) in recipients"
							v-bind:key="index"
						>
							{{ recipient.displayName }}
							<a @click="removeRecipient(recipient)"><b-icon icon="x"></b-icon></a>
						</span>
						<span
							class="badge badge-primary badge-sm mr-2 mb-2"
							v-if="recipients.length"
							@click="openModal"
						>
							<b-icon icon="plus"></b-icon> {{ $t("add") }}
						</span>
						<span
							class="badge badge-danger badge-sm mr-2 mb-2"
							v-if="recipients.length"
							@click="recipients=[]"
						>
							<b-icon icon="x"></b-icon> {{ $t('clear-all') }}
						</span>
					</div>
					<span class="text-error" v-if="recipientsError">{{
						$t("please-select-at-least-one-user")
					}}</span>
				</div>
				<input
					class="form-control mb-4"
					type="text"
					v-model="subject"
					data-cy="message-subject"
					:placeholder="$t('subject')"
				/>
				<textarea
					class="form-control"
					:class="{ error: errors.message }"
					style="height: 200px"
					v-model="content"
					data-cy="message-content"
					:placeholder="$t('message')"
					name="message"
					required
					v-validate
				></textarea>
				<div class="text-error">{{ errors.message }}</div>

				<!--
				<div class="form-check mt-3">
					<label class="form-check-label" for="important">
						<input type="checkbox" class="form-check-input" id="important" v-model="important">
							{{ $t('mark-as-important') }}
					</label>
				</div>
				-->
				<button class="btn btn-danger mt-4" @click="sendMessage" :disabled="saving" data-cy="send-message-button">{{ $t('send-message') }}</button>
			</div>
			<!--
      <div class="col-4">
        <aside class="aside">
          <h2>Recipients</h2>
        </aside>
      </div> -->
		</div>
	</div>
</template>

<script>
import { ValidateMixin } from "@/mixins";
export default {
	mixins: [ValidateMixin],
	data: function() {
		return {
			subject: "",
			content: "",
			recipients: [],
			recipientsError: false,
			users: [],
			important: false,
			saving: false
		}
	},
	mounted() {
		// teachers can message students and teachers
		// students can only message teachers
		this.getUsers();
	},
	methods: {
		getUsers() {
				this.$cfetch(`${this.$settings.APIBaseURL}/getusers`,
					{
						method: "post",
						data: {
							priv: 'SERIOUSCONCERN_NOTIFY'
						}
					}
				)
				.then(json => {
					if (json.status == "SUCCESS") {
						this.users = json.users
					}
				})
				.catch(error => {
					this.$log.error.call(this, error);
				});
		},
		openModal() {
			const self = this;
			this.$store.commit("openModal", {
				type: "selector",
				title: this.$t("select-recipients"),
				selectCallback: function(selection) {
					const isSelected = self.recipients.find((recipient, i) => {
						if (recipient.id === selection.id) {
							self.$delete(self.recipients, i);
							return true;
						}
					});
					if (!isSelected) {
						self.recipients.push(selection);
					}
					self.recipientsError = false;
				},
				selected: this.recipients,
				data: this.users,
				captionKey: "displayName",
				studentSearchFilters: this.$UserSession.hasPriv("SERIOUSCONCERN_NOTIFY"),
				selectAllBtn: this.$UserSession.hasPriv("SERIOUSCONCERN_NOTIFY")
			});
		},
		removeRecipient(selection) {
			const self = this;
			self.recipients.find((student, i) => {
				if (student.id === selection.id) {
					self.$delete(self.recipients, i);
					return true;
				}
			});
			return false;
		},
		sendMessage() {
			// a second tap while sending would send the message twice
			if (this.saving) {
				return false;
			}
			this.validate();

			this.recipientsError = !this.recipients.length && !this.$route.params.threadid;
			// todo: would like to integrate this into v-validate somehow
			if (this.hasErrors || this.recipientsError) {
				return false;
			}

			if (this.recipients.length || this.$route.params.threadid) {
				var message = {
					subject: this.subject,
					content: this.content,
					to: [],
					important: true,
					seriousconcern: true
				}
				for(let recipient of this.recipients){
					message.to.push(recipient.id);
				}
				const data = {
					message
				}
				if(this.$route.params.threadid) {
					data.thread_id = this.$route.params.threadid
				}
				if(this.$route.query.replyto) {
					data.replyto = this.$route.query.replyto;
				}

				this.saving = true;
				this.$store.commit("showBlockingSpinner");
				this.$cfetch(`${this.$settings.APIBaseURL}/messages/send`,
					{
						method: "post",
						data
					}
				)
				.then(this.$assertApiSuccess)
				.then(() => {
					this.$store.commit("hideBlockingSpinner");
					this.$store.commit("openDialog", {
						title: this.$t("message-sent"),
						content: this.$t("your-message-has-been-sent"),
						cypressId: "message-sent",
						confirmCallBack: function() {
							this.$router.replace("/messages/list");
						}
					});
				})
				.catch(err => {
					this.$store.commit("hideBlockingSpinner");
					this.saving = false;
					this.$showApiError(err, { fallback: "could-not-send-message" });
				});
			} else {
				this.$store.commit("openDialog", this.$t("no-recipients-specified"));
			}
		}
	}
};
</script>
